import React from "react";
import ReactDOM from "react-dom/client";
import Routes from "./routes";
import { HashRouter } from "react-router-dom";
import { store } from './store';
import { Provider } from 'react-redux';
import "./index.css";
import { ThemeProvider } from '@material-ui/core/styles';
import { createTheme } from '@material-ui/core/styles';

const root = ReactDOM.createRoot(document.getElementById("root"));

const theme = createTheme({
  palette: {
    primary: {
      main: '#406599',
    },
    secondary: {
      main: '#E3F2FD',
    },
  },
  typography: {
    fontFamily: [
      "serif",
      'sans-serif',
    ].join(','),
  },
});

root.render(
	<Provider store={store}>
	  <HashRouter>
	  <ThemeProvider theme={theme}>
	    <Routes />
	    </ThemeProvider>
	  </HashRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//  <React.StrictMode>
//    <Home />
//  </React.StrictMode>
//	<BrowserRouter>
//   <Switch>
//      <AppRouter />
//    </Switch>
//  </BrowserRouter>